import { render, staticRenderFns } from "./PayVirementSection.vue?vue&type=template&id=485491ef&scoped=true&"
import script from "./PayVirementSection.vue?vue&type=script&lang=js&"
export * from "./PayVirementSection.vue?vue&type=script&lang=js&"
import style0 from "./PayVirementSection.vue?vue&type=style&index=0&id=485491ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485491ef",
  null
  
)

export default component.exports